/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The Account model module.
 * @module model/Account
 * @version v0
 */
export default class Account {
  /**
   * Constructs a new <code>Account</code>.
   * @alias module:model/Account
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>Account</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Account} obj Optional instance to populate.
   * @return {module:model/Account} The populated <code>Account</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new Account();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('numberOfEditors'))
        obj.numberOfEditors = ApiClient.convertToType(data['numberOfEditors'], 'Number');
      if (data.hasOwnProperty('numberOfViewers'))
        obj.numberOfViewers = ApiClient.convertToType(data['numberOfViewers'], 'Number');
      if (data.hasOwnProperty('numberOfSources'))
        obj.numberOfSources = ApiClient.convertToType(data['numberOfSources'], 'Number');
      if (data.hasOwnProperty('numberOfSnapshots'))
        obj.numberOfSnapshots = ApiClient.convertToType(data['numberOfSnapshots'], 'Number');
      if (data.hasOwnProperty('currentPlanId'))
        obj.currentPlanId = ApiClient.convertToType(data['currentPlanId'], 'String');
      if (data.hasOwnProperty('dateAdded'))
        obj.dateAdded = ApiClient.convertToType(data['dateAdded'], 'Number');
      if (data.hasOwnProperty('paymentMethod'))
        obj.paymentMethod = ApiClient.convertToType(data['paymentMethod'], 'String');
      if (data.hasOwnProperty('paymentProcessorId'))
        obj.paymentProcessorId = ApiClient.convertToType(data['paymentProcessorId'], 'String');
      if (data.hasOwnProperty('paymentLength'))
        obj.paymentLength = ApiClient.convertToType(data['paymentLength'], 'String');
      if (data.hasOwnProperty('paymentType'))
        obj.paymentType = ApiClient.convertToType(data['paymentType'], 'String');
      if (data.hasOwnProperty('firstName'))
        obj.firstName = ApiClient.convertToType(data['firstName'], 'String');
      if (data.hasOwnProperty('lastName'))
        obj.lastName = ApiClient.convertToType(data['lastName'], 'String');
      if (data.hasOwnProperty('companyName'))
        obj.companyName = ApiClient.convertToType(data['companyName'], 'String');
      if (data.hasOwnProperty('currencyCode'))
        obj.currencyCode = ApiClient.convertToType(data['currencyCode'], 'String');
      if (data.hasOwnProperty('defaultAdmin'))
        obj.defaultAdmin = ApiClient.convertToType(data['defaultAdmin'], 'String');
      if (data.hasOwnProperty('defaultEmail'))
        obj.defaultEmail = ApiClient.convertToType(data['defaultEmail'], 'String');
      if (data.hasOwnProperty('streetAddress'))
        obj.streetAddress = ApiClient.convertToType(data['streetAddress'], 'String');
      if (data.hasOwnProperty('suite'))
        obj.suite = ApiClient.convertToType(data['suite'], 'String');
      if (data.hasOwnProperty('state'))
        obj.state = ApiClient.convertToType(data['state'], 'String');
      if (data.hasOwnProperty('city'))
        obj.city = ApiClient.convertToType(data['city'], 'String');
      if (data.hasOwnProperty('postcode'))
        obj.postcode = ApiClient.convertToType(data['postcode'], 'String');
      if (data.hasOwnProperty('country'))
        obj.country = ApiClient.convertToType(data['country'], 'String');
      if (data.hasOwnProperty('phoneNumber'))
        obj.phoneNumber = ApiClient.convertToType(data['phoneNumber'], 'String');
      if (data.hasOwnProperty('subscriptionRef'))
        obj.subscriptionRef = ApiClient.convertToType(data['subscriptionRef'], 'String');
      if (data.hasOwnProperty('subscriptionStartDate'))
        obj.subscriptionStartDate = ApiClient.convertToType(data['subscriptionStartDate'], 'Number');
      if (data.hasOwnProperty('subscriptionCancelationDate'))
        obj.subscriptionCancelationDate = ApiClient.convertToType(data['subscriptionCancelationDate'], 'Number');
      if (data.hasOwnProperty('validUntil'))
        obj.validUntil = ApiClient.convertToType(data['validUntil'], 'Date');
      if (data.hasOwnProperty('dateFormat'))
        obj.dateFormat = ApiClient.convertToType(data['dateFormat'], 'String');
      if (data.hasOwnProperty('status'))
        obj.status = ApiClient.convertToType(data['status'], 'Number');
      if (data.hasOwnProperty('vat'))
        obj.vat = ApiClient.convertToType(data['vat'], 'String');
      if (data.hasOwnProperty('lastReminder'))
        obj.lastReminder = ApiClient.convertToType(data['lastReminder'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
Account.prototype.id = undefined;

/**
 * @member {String} name
 */
Account.prototype.name = undefined;

/**
 * @member {Number} numberOfEditors
 */
Account.prototype.numberOfEditors = undefined;

/**
 * @member {Number} numberOfViewers
 */
Account.prototype.numberOfViewers = undefined;

/**
 * @member {Number} numberOfSources
 */
Account.prototype.numberOfSources = undefined;

/**
 * @member {Number} numberOfSnapshots
 */
Account.prototype.numberOfSnapshots = undefined;

/**
 * @member {String} currentPlanId
 */
Account.prototype.currentPlanId = undefined;

/**
 * @member {Number} dateAdded
 */
Account.prototype.dateAdded = undefined;

/**
 * @member {String} paymentMethod
 */
Account.prototype.paymentMethod = undefined;

/**
 * @member {String} paymentProcessorId
 */
Account.prototype.paymentProcessorId = undefined;

/**
 * @member {String} paymentLength
 */
Account.prototype.paymentLength = undefined;

/**
 * @member {String} paymentType
 */
Account.prototype.paymentType = undefined;

/**
 * @member {String} firstName
 */
Account.prototype.firstName = undefined;

/**
 * @member {String} lastName
 */
Account.prototype.lastName = undefined;

/**
 * @member {String} companyName
 */
Account.prototype.companyName = undefined;

/**
 * @member {String} currencyCode
 */
Account.prototype.currencyCode = undefined;

/**
 * @member {String} defaultAdmin
 */
Account.prototype.defaultAdmin = undefined;

/**
 * @member {String} defaultEmail
 */
Account.prototype.defaultEmail = undefined;

/**
 * @member {String} streetAddress
 */
Account.prototype.streetAddress = undefined;

/**
 * @member {String} suite
 */
Account.prototype.suite = undefined;

/**
 * @member {String} state
 */
Account.prototype.state = undefined;

/**
 * @member {String} city
 */
Account.prototype.city = undefined;

/**
 * @member {String} postcode
 */
Account.prototype.postcode = undefined;

/**
 * @member {String} country
 */
Account.prototype.country = undefined;

/**
 * @member {String} phoneNumber
 */
Account.prototype.phoneNumber = undefined;

/**
 * @member {String} subscriptionRef
 */
Account.prototype.subscriptionRef = undefined;

/**
 * @member {Number} subscriptionStartDate
 */
Account.prototype.subscriptionStartDate = undefined;

/**
 * @member {Number} subscriptionCancelationDate
 */
Account.prototype.subscriptionCancelationDate = undefined;

/**
 * @member {Date} validUntil
 */
Account.prototype.validUntil = undefined;

/**
 * @member {String} dateFormat
 */
Account.prototype.dateFormat = undefined;

/**
 * @member {Number} status
 */
Account.prototype.status = undefined;

/**
 * @member {String} vat
 */
Account.prototype.vat = undefined;

/**
 * @member {Number} lastReminder
 */
Account.prototype.lastReminder = undefined;

